import { render, staticRenderFns } from "./area-chart.vue?vue&type=template&id=c179e5c4"
import script from "./area-chart.vue?vue&type=script&lang=js"
export * from "./area-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports